module.exports = __webpack_public_path__ + "1642699981952/static/media/user-circle-solid.fd7022cf.svg";